import { Grid, Tab, Tabs } from "@mui/material"
import { StaticDataAccordion } from "../../Component/Common/Components/Accordion/StaticDataAccordion";
import "./Legislation.css"
import { LegislationService } from "../../Component/Api/Legislation/LegislationService";
import { urltoFile } from "../../Component/Model/helpers";
import { ModuleType } from "../../Component/Model/Enum/BEE123Enums";
import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { WspAtr_Legislations_Mandates } from "../../Component/Common/Constants/StaticPageConstants/WSP/WSPATR_Legislation_Mandates";
import { WspAtr_MerSETA_Documents } from "../../Component/Common/Constants/StaticPageConstants/WSP/WSPATR_MerSETA_Documents";
import { WspAtr_MerSETA_Templates } from "../../Component/Common/Constants/StaticPageConstants/WSP/WSPATR_MerSETA_Templates";

export const WspAtrLegislationResourcesPage = () => {
    
    const routes = [
        "/legislation/WSPATR/Legislation",
        "/legislation/WSPATR/SetaDocuments",
        "/legislation/WSPATR/SetaTemplates",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="WSP/ATR Legislation" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="SETA Documents" value={routes[1]} to={routes[1]} component={Link}/>
                        <Tab label= "SETA Templates" value={routes[2]} to={routes[2]} component={Link}/>
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <WspAtrLegislationPage />
                        </Route>
                        <Route path={routes[1]}>
                            <SETADocumentsPage/>
                        </Route>
                        <Route path={routes[2]}>
                            <SETATemplates/>
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>
    );
};


export const WspAtrLegislationPage =() => {
    const followLink = async(link: string | undefined, section: number | undefined) =>{
        if(link !== undefined && section !== undefined){
            try{
                const result = await LegislationService.GetLegislationDocument(link, ModuleType.WSP_Module, section);
                const file = await urltoFile('data:text/plain;base64,' + result.data.fileContents, link, 'application/pdf')
                const url = URL.createObjectURL(file);
                const documentLink = document.createElement("a");
                documentLink.setAttribute("href", url);
                documentLink.setAttribute("download", result.data.fileDownloadName !== undefined? result.data.fileDownloadName: link);
                document.body.appendChild(documentLink);
                documentLink.click();
                document.body.removeChild(documentLink);

            }catch(error) {
                console.log(error)
            }
        }
    }
    return (
        <>
        <Grid container style={{ padding: "15px" }}>
            <Grid item xs={12} lg={12} mt={2}>
                    {WspAtr_Legislations_Mandates.map((leg, index) => {
                    return <StaticDataAccordion key={index} {...leg} followLink={followLink}/>;
                    })}
                </Grid>
        </Grid>
        </>
    )
}

export const SETADocumentsPage =() => {
    const followLink = async(link: string | undefined, section: number | undefined) =>{
        if(link !== undefined && section !== undefined){
            try{
                const result = await LegislationService.GetLegislationDocument(link, ModuleType.WSP_Module, section);
                const file = await urltoFile('data:text/plain;base64,' + result.data.fileContents, link, 'application/pdf')
                const url = URL.createObjectURL(file);
                const documentLink = document.createElement("a");
                documentLink.setAttribute("href", url);
                documentLink.setAttribute("download", result.data.fileDownloadName !== undefined? result.data.fileDownloadName: link);
                document.body.appendChild(documentLink);
                documentLink.click();
                document.body.removeChild(documentLink);

            }catch(error) {
                console.log(error)
            }
        }
    }
    return (
        <>
        <Grid container style={{ padding: "15px" }}>
            <Grid item xs={12} lg={12} mt={2}>
                    {WspAtr_MerSETA_Documents.map((leg, index) => {
                    return <StaticDataAccordion key={index} {...leg} followLink={followLink}/>;
                    })}
                </Grid>
        </Grid>
        </>
    )

    
}



export const SETATemplates =() => {
    const followLink = async (link: string | undefined, section: number | undefined) => {
        if (link !== undefined && section !== undefined) {
            try {
                const result = await LegislationService.GetLegislationDocument(link, ModuleType.WSP_Module, section);
                let file;
                let fileType = result.data.contentType; // Assuming you have a way to determine the file type
    
                if (fileType === 'application/pdf') {
                    file = await urltoFile('data:application/pdf;base64,' + result.data.fileContents, link, 'application/pdf');
                } else if (fileType === 'text/csv') {
                    const csvData = atob(result.data.fileContents);
                    file = new Blob([csvData], { type: 'text/csv' });
                } else if (fileType === 'application/xlsx' || fileType === 'application/xls') {
                    const workbookData = atob(result.data.fileContents);
                    file = new Blob([workbookData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                } else {
                    throw new Error('Unsupported file format');
                }
    
                const url = URL.createObjectURL(file);
                const documentLink = document.createElement("a");
                documentLink.setAttribute("href", url);
                documentLink.setAttribute("download", result.data.fileDownloadName !== undefined ? result.data.fileDownloadName : link);
                document.body.appendChild(documentLink);
                documentLink.click();
                document.body.removeChild(documentLink);
    
            } catch (error) {
                console.log(error);
            }
        }
    }
    return (
        <>
        <Grid container style={{ padding: "15px" }}>
            <Grid item xs={12} lg={12} mt={2}>
                    {WspAtr_MerSETA_Templates.map((leg, index) => {
                    return <StaticDataAccordion key={index} {...leg} followLink={followLink}/>;
                    })}
                </Grid>
        </Grid>
        </>
    )

    
}
